import React from 'react';
import TableCotizacionTbody from './TableCotizacionTbody';
import TableCotizacionThead from './TableCotizacionThead';

const TableCotizacion = (props) => {
  const { handleAprobar, handlePDF } = props.actions;
  const { loadingTables, cotizacionData, cotizacionError } = props.data;
  const hasData = Array.isArray(cotizacionData?.data) && cotizacionData.data.length > 0;
  const hasFetched = Object.prototype.hasOwnProperty.call(cotizacionData || {}, 'data');

  return (
    <div className="overflow-x-auto">
      {!loadingTables && (
        <table className="w-full table-auto text-sm">
          <TableCotizacionThead data={props.data} />
          {hasData && (
            <TableCotizacionTbody
              endPoint={props.endPoint}
              data={props.data}
              modals={props.modals}
              handleAprobar={handleAprobar}
              handlePDF={handlePDF}
            />
          )}
          {hasFetched && !hasData && (
            <tbody>
              <tr>
                <td
                  colSpan={10}
                  className="p-4 text-center text-gray-500">
                  {cotizacionError ? 'Error al cargar cotizaciones.' : 'No hay cotizaciones para mostrar.'}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      )}
    </div>
  );
};
export default TableCotizacion;
